export default __webpack_public_path__ + "static/media/prev-IVTS-5.a68e03f1.png";